import LogRocket from 'logrocket';
import { isStage } from './constants/gcp.js';

export default LogRocket;

let didInit = false;

const initLogRocket = () => {
  const logRocketAppId = process.env.LOG_ROCKET_APP_ID;
  if (!logRocketAppId || didInit) return;
  didInit = true;

  LogRocket.init(logRocketAppId, {
    release: process.env.RELEASE || 'unknown',
    rootHostname: 'bambuser.com',
    shouldCaptureIP: false,
    shouldDebugLog: isStage,
    console: {
      // Disable tracking of console.log and console.debug
      isEnabled: {
        log: false,
        debug: false,
      },
    },
    dom: {
      // Obfuscate all input nodes from all session recordings
      inputSanitizer: true,
    },
    network: {
      requestSanitizer: request => {
        // OAuth completion contains an API key in the body; never record it.
        // An unparseable URL is dropped rather than risk recording it.
        try {
          if (new URL(request.url, window.location.origin).pathname.endsWith('/oauth/complete')) return null;
        } catch {
          return null;
        }

        if (!request.url.includes('bambuser.com')) {
          // Skip non-bambuser requests
          return null;
        }

        // scrub most headers from request
        for (const header of Object.keys(request.headers)) {
          if (![
            'user-agent',
          ].includes(header.toLowerCase())) {
            delete request.headers[header];
          }
        }
        return request;
      },
    },
  });
};

export { initLogRocket };
